import React, {ReactElement, JSXElementConstructor} from 'react';
import {ThemeProvider} from 'styled-components';

import {MainScreen} from 'views/MainScreen';
import {SettingsView} from 'views/Settings';
import {KeyboardView} from 'views/Keyboard';
import {HistoryView} from 'views/History';
import {StartupView} from 'views/Startup';
import {SummaryView} from './views/Summary';
import {NewDayScreen} from 'views/NewDayScreen';

import {MessagesReceiver} from 'ui/adapters/MessagesReceiver';
import {MessagesEmitter} from 'ui/adapters/MessagesEmitter';
import {PromoConnector} from 'ui/adapters/PromoMessage';
import {IsInstallable} from 'ui/adapters/Device';
import {NewDayStarted} from 'ui/adapters/Core';
import {ShowSummary} from 'ui/adapters/Screen';

import {GlobalStyle, theme} from 'ui/theme';
import {StoreProvider} from 'store/Provider';

type Option = JSXElementConstructor<IndexSignature>;
type Selector = (condition: boolean) => ReactElement;

function Either(Right: Option, Left: Option): Selector {
  return function Selector(condition: boolean): ReactElement {
    return condition ? <Right /> : <Left />;
  };
}

const DefaultRoot = (): ReactElement => (
  <>
    <MainScreen />
    <SettingsView />
    <HistoryView />
    <KeyboardView />
  </>
);

export const App = (): ReactElement => (
  <StoreProvider>
    <GlobalStyle />

    <MessagesEmitter />
    <MessagesReceiver />
    <PromoConnector />

    <ThemeProvider theme={theme}>
      <IsInstallable>
        {Either(StartupView, () => (
          <NewDayStarted>
            {Either(NewDayScreen, () => (
              <ShowSummary>{Either(SummaryView, DefaultRoot)}</ShowSummary>
            ))}
          </NewDayStarted>
        ))}
      </IsInstallable>
    </ThemeProvider>
  </StoreProvider>
);
